const routes = [
    {
        path: '',
        name: 'login',
        meta: {
            title: '登录',
        },
        component: () => import('@/views/login.vue')
    },
    {
        path: '/test',
        name: 'test',
        meta: {
            title: '测试数据',
        },
        component: () => import('@/views/test.vue')
    },
    {
        path: '/error/:status',
        name: 'error',
        meta: {
            title: '错误',
        },
        component: () => import('@/views/error.vue')
    },
    {
        path: '/admin',
        meta: {
            title: '首页',
        },
        component: () => import('@/components/layout.vue'),
        children:[
            {
                id: 0,
                title: "仪表盘",
                icon: "ios-speedometer",
                name: "dashboard",
                path: "",
                view: "views/dashboard"
            },
        ]
    }
]

export default [
    ...routes,
]
